var _g, _path, _rect, _rect2, _circle, _rect3, _rect4, _rect5, _rect6, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _circle3, _circle4, _circle5, _path8, _path9, _rect7, _rect8, _circle6, _circle7, _circle8, _path10, _rect9, _rect10, _rect11, _path11, _path12, _rect12, _path13, _path14, _path15, _path16, _path17, _path18, _circle9, _circle10, _circle11, _path19, _path20, _path21, _circle12, _circle13, _path22, _circle14, _circle15, _path23, _path24, _path25, _path26, _path27, _path28, _circle16, _path29, _path30, _path31, _circle17, _path32, _path33, _path34, _path35, _path36, _path37, _rect13, _rect14, _path38, _path39, _rect15, _path40, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _path41, _path42, _path43, _rect24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFte3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.3646 427.186C83.3646 427.186 -7.40643 319.2 19.7846 291.563C46.9756 263.926 92.6736 294.093 84.8456 263.293C77.0176 232.493 45.8266 202.615 58.4316 179.242C73.5626 151.187 117.839 173.95 139.28 183.774C179.141 202.038 223.313 204.064 208.005 178.521C192.697 152.978 152.621 128.021 167.157 113.463C186.939 93.653 295.719 166.986 342.274 224.412C370.137 258.781 390.444 234.866 387.623 212.786C385.83 198.752 366.094 169.793 386.797 156.686C406.754 144.052 453.364 183.204 469.197 207.379C510.655 270.679 442.777 426.571 442.777 426.571L83.3646 427.186Z",
    fill: "#C5CEDA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.776 177.312V231.501H121.756V130.303H260.776V177.312",
    fill: "#E1E1E1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 157,
    width: 108,
    height: 60,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 156.029,
    y: 204,
    width: 11.924,
    height: 4.882,
    rx: 2.441,
    transform: "rotate(0.349 156.029 204)",
    fill: "#E1E1E1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 165.451,
    cy: 206.497,
    r: 2.487,
    fill: "#4A90E2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 162,
    width: 36,
    height: 3,
    fill: "#E1E1E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 171,
    width: 56,
    height: 3,
    fill: "#979797"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 192,
    width: 41,
    height: 3,
    fill: "#979797"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 183,
    width: 36,
    height: 3,
    fill: "#E1E1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233 169H157C155.895 169 155 169.895 155 171V174C155 175.105 155.895 176 157 176H233C234.105 176 235 175.105 235 174V171C235 169.895 234.105 169 233 169ZM157 168C155.343 168 154 169.343 154 171V174C154 175.657 155.343 177 157 177H233C234.657 177 236 175.657 236 174V171C236 169.343 234.657 168 233 168H157Z",
    fill: "#459BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233 190H157C155.895 190 155 190.895 155 192V195C155 196.105 155.895 197 157 197H233C234.105 197 235 196.105 235 195V192C235 190.895 234.105 190 233 190ZM157 189C155.343 189 154 190.343 154 192V195C154 196.657 155.343 198 157 198H233C234.657 198 236 196.657 236 195V192C236 190.343 234.657 189 233 189H157Z",
    fill: "#459BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.777 137.73V146.289H121.756V130.305H260.777V137.73",
    fill: "#4A90E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.181 129.611H137.74V231.504H121.756V129.611H129.181",
    fill: "#055CC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.244 233.015H263.227V128.1H120.244V233.015ZM260.204 229.992H123.267V131.123H260.204V229.992Z",
    fill: "#0134A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.244 233.015H263.227V128.1H120.244V233.015ZM260.204 229.992H123.267V131.123H260.204V229.992Z",
    fill: "#0134A0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.748,
    cy: 156.772,
    r: 3.955,
    fill: "#E6E6E8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.748,
    cy: 169.139,
    r: 3.955,
    fill: "#E6E6E8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.748,
    cy: 181.506,
    r: 3.955,
    fill: "#E6E6E8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.748,
    cy: 193.873,
    r: 3.955,
    fill: "#8896AA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M222.349 426.661H254.116V416.908H232.977L220.845 422.063C219.916 422.384 219.27 423.232 219.208 424.213V424.213C219.208 425.565 220.614 426.661 222.349 426.661Z",
    fill: "#192335"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M264.806 426.661H296.573V416.908H275.433L263.299 422.063C262.369 422.384 261.723 423.231 261.661 424.213V424.213C261.664 425.565 263.071 426.661 264.806 426.661Z",
    fill: "#192335"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 115.727,
    y: 231.503,
    width: 196.796,
    height: 8.464,
    fill: "#0134A0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 115.727,
    y: 231.503,
    width: 196.796,
    height: 8.464,
    fill: "#0134A0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.455,
    cy: 292.721,
    r: 11.28,
    fill: "#AB9AF7"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.751,
    cy: 290.488,
    r: 13.313,
    fill: "#AB9AF7"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 313.94,
    cy: 290.492,
    r: 13.313,
    fill: "#AB9AF7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M327.912 277.179L327.259 290.492L327.227 291.145C326.879 298.236 321.027 303.807 313.927 303.805H270.775C263.675 303.807 257.823 298.236 257.475 291.145L257.443 290.492L256.79 277.179L327.912 277.179Z",
    fill: "#AB9AF7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 77.3486,
    y: 237.782,
    width: 369.993,
    height: 10.573,
    fill: "#0134A0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 103.216,
    y: 438.098,
    width: 183.74,
    height: 1.453,
    fill: "#293F51"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 311,
    y: 438,
    width: 93.918,
    height: 1.453,
    fill: "#293F51"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.264 247.389L108.278 256.785L89.5897 427.227H84.8457L98.8727 247.389H109.264V247.389Z",
    fill: "#0134A0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M407.834 247.389L408.821 256.785L427.508 427.227H432.252L418.226 247.389H407.834V247.389Z",
    fill: "#0134A0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3232,
    y: 426.468,
    width: 470.4,
    height: 1.453,
    fill: "#293F51"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.46 195.191H254.8V191.811H239.46V195.191ZM254.5 194.891H239.762L239.761 192.113H254.5V194.891Z",
    fill: "#055CC0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M276.564 317.412L219.269 317.653L218.378 281.506L275.513 276.344L276.564 317.412V317.412Z",
    fill: "#658FDF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M225.551 213.648L300.888 228.397L299.77 239.995L295.815 239.996L289.971 239.995L223.013 240.014L225.551 213.648V213.648Z",
    fill: "#C9DEF6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M299.773 239.991L300.891 228.393L295.818 227.4V239.992L299.773 239.991V239.991Z",
    fill: "#C9DEF6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M278.538 155.513H314.08V116.587C314.08 104.747 304.481 95.1486 292.641 95.148V95.148C281.203 95.148 270.806 104.127 270.253 115.548L268.814 145.303C268.685 147.964 269.651 150.562 271.489 152.492C273.326 154.421 275.874 155.513 278.538 155.513Z",
    fill: "#E6BBA6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M305.107 186.261H296.266C291.312 186.261 287.295 182.245 287.295 177.29V145.617H314.074V177.291C314.074 182.245 310.058 186.261 305.104 186.261L305.107 186.261Z",
    fill: "#E6BBA6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 300.688,
    cy: 172.87,
    r: 13.391,
    fill: "#E6BBA6"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.509,
    cy: 292.721,
    r: 11.28,
    fill: "#4A90E2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.509,
    cy: 292.721,
    r: 11.28,
    fill: "#658FDF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M256.263 417.552L238.398 292.076L208.273 293.843L227.351 417.552H256.263V417.552Z",
    fill: "#658FDF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M298.401 417.552L280.536 292.076L250.411 293.843L269.489 417.552H298.401V417.552Z",
    fill: "#658FDF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M333.962 277.179C333.968 281.742 333.09 286.263 331.377 290.492H265.427C260.058 277.191 263.206 261.967 273.409 251.886C283.612 241.805 298.872 238.841 312.108 244.369C325.343 249.897 333.961 262.836 333.962 277.179Z",
    fill: "#AB9AF7"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.398,
    cy: 277.179,
    r: 9.753,
    fill: "#40327A"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.836,
    cy: 226.642,
    r: 13.304,
    transform: "rotate(-4.699 373.836 226.642)",
    fill: "#C9DEF6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M313.691 201.198L366.263 237.585L383.379 217.375L338.787 171.565L313.691 201.198V201.198Z",
    fill: "#C9DEF6"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 324.793,
    cy: 185.16,
    r: 19.506,
    transform: "rotate(-18.744 324.793 185.16)",
    fill: "#C9DEF6"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 312.786,
    cy: 238.673,
    r: 7.802,
    transform: "rotate(-56.899 312.786 238.673)",
    fill: "#FF95A9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M305.514 235.261C305.059 237.584 303.25 239.404 300.93 239.873C298.61 240.342 296.236 239.367 294.915 237.403C293.594 235.439 293.586 232.873 294.895 230.901C296.204 228.929 298.572 227.939 300.895 228.394C302.418 228.692 303.761 229.583 304.627 230.871C305.493 232.159 305.812 233.738 305.514 235.261V235.261Z",
    fill: "#FF95A9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M309.196 245.603L297.078 239.334L300.894 228.394L314.284 231.015L309.196 245.603V245.603Z",
    fill: "#FF95A9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M236.056 229.256C234.643 236.463 227.656 241.161 220.448 239.749C213.241 238.337 208.542 231.351 209.952 224.143C211.363 216.935 218.348 212.235 225.556 213.644C229.019 214.321 232.072 216.346 234.041 219.275C236.01 222.203 236.735 225.793 236.056 229.256V229.256Z",
    fill: "#C9DEF6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M283.115 201.185L230.584 237.631L213.445 217.44L257.986 171.581L283.115 201.185V201.185Z",
    fill: "#C9DEF6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M283.119 201.184L239.502 231.444L221.009 209.648L257.985 171.578L283.119 201.184V201.184Z",
    fill: "#C9DEF6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M313.691 201.198L357.341 231.41L375.81 209.594L338.792 171.565L313.691 201.198V201.198Z",
    fill: "#C9DEF6"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.996,
    cy: 185.158,
    r: 19.506,
    transform: "rotate(-71.334 271.996 185.158)",
    fill: "#C9DEF6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M338.726 179.976L333.957 277.176H262.838L258.069 179.976C257.886 176.243 259.241 172.598 261.818 169.891C264.396 167.184 267.97 165.652 271.707 165.652H325.088C328.826 165.652 332.4 167.184 334.977 169.891C337.555 172.598 338.91 176.243 338.726 179.976Z",
    fill: "#C9DEF6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M334.479 277.661L377.873 427.183H382.859L347.376 277.661H334.479V277.661Z",
    fill: "#0134A0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M289.105 277.661L245.711 427.183H240.724L276.207 277.661H289.105V277.661Z",
    fill: "#0134A0"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 311.792,
    cy: 256.333,
    r: 73.078,
    fill: "#000B64"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M323.643 210.331H299.943C298.632 210.332 297.375 209.813 296.448 208.886C295.521 207.96 295 206.704 295 205.393V205.393C295 202.666 297.211 200.455 299.938 200.455H323.638C324.948 200.455 326.203 200.975 327.129 201.901C328.055 202.827 328.575 204.083 328.575 205.393V205.393C328.576 208.118 326.368 210.328 323.643 210.331V210.331Z",
    fill: "#C9DEF6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M265.528 97.9621V109.538C265.525 110.412 265.633 111.282 265.85 112.128H287.629V86.2791H277.212C274.113 86.278 271.141 87.5085 268.95 89.6997C266.758 91.8909 265.528 94.8631 265.528 97.9621V97.9621Z",
    fill: "#8896AA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M324.791 128.139H302.401V91.487H309.791C318.075 91.487 324.791 98.2028 324.791 106.487V128.139Z",
    fill: "#8896AA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M267.199 109.647H290.351C299.4 109.637 306.733 102.303 306.743 93.254C306.775 90.4504 305.297 87.8461 302.875 86.4351C300.452 85.024 297.458 85.024 295.035 86.4351C292.612 87.8461 291.134 90.4504 291.166 93.254C291.166 93.7039 290.801 94.0685 290.351 94.069H267.199V109.647Z",
    fill: "#8896AA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M275.473 101.856H287.48C290.284 101.888 292.888 100.41 294.299 97.9875C295.71 95.5646 295.71 92.5704 294.299 90.1476C292.888 87.7247 290.284 86.2472 287.48 86.279H275.473C272.669 86.2472 270.065 87.7247 268.654 90.1476C267.243 92.5704 267.243 95.5646 268.654 97.9875C270.065 100.41 272.669 101.888 275.473 101.856Z",
    fill: "#8896AA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M263.273 106.9C263.274 113.385 268.531 118.642 275.016 118.643C281.502 118.643 287.629 113.385 287.629 106.9C287.629 100.415 281.499 95.156 275.016 95.156C271.902 95.156 268.915 96.3933 266.713 98.5958C264.51 100.798 263.273 103.785 263.273 106.9Z",
    fill: "#8896AA"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 307.69,
    y: 115.697,
    width: 32.453,
    height: 12.17,
    transform: "rotate(-180 307.69 115.697)",
    fill: "#8896AA"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 306.758,
    y: 131.059,
    width: 25.07,
    height: 15.523,
    transform: "rotate(-180 306.758 131.059)",
    fill: "#8896AA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M311.12 152.798H298.82C292.586 152.796 287.532 147.742 287.53 141.508V124.798H324.79V139.138C324.787 146.685 318.667 152.8 311.12 152.798V152.798Z",
    fill: "#8896AA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M287.528 125.217H282.364C277.195 125.217 273.005 121.027 273.005 115.858V111.246H287.528V125.217Z",
    fill: "#8896AA"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 282.367,
    y: 158.174,
    width: 35,
    height: 10.965,
    fill: "#C9DEF6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M281.688 136.772H275.846V125.089H281.688C284.914 125.089 287.529 127.704 287.53 130.93V130.93C287.53 134.156 284.914 136.772 281.688 136.772V136.772Z",
    fill: "#E6BBA6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.5 128H166V173H120.5V128Z",
    fill: "#E1E1E1",
    style: {
      mixBlendMode: "multiply"
    }
  }), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 60.8096,
    y: 102.437,
    width: 101.185,
    height: 67.214,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 108,
    width: 36,
    height: 3,
    fill: "#E1E1E1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 117,
    width: 56,
    height: 3,
    fill: "#979797"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 138,
    width: 41,
    height: 3,
    fill: "#979797"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 129,
    width: 36,
    height: 3,
    fill: "#E1E1E1"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 150,
    width: 36,
    height: 3,
    fill: "#E1E1E1"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 57.7646,
    y: 89.901,
    width: 104.23,
    height: 12.536,
    fill: "#4A90E2"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 57.7637,
    y: 169.651,
    width: 79.75,
    height: 3.045,
    transform: "rotate(-90 57.7637 169.651)",
    fill: "#4A90E2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147 115H71C69.8954 115 69 115.895 69 117V120C69 121.105 69.8954 122 71 122H147C148.105 122 149 121.105 149 120V117C149 115.895 148.105 115 147 115ZM71 114C69.3431 114 68 115.343 68 117V120C68 121.657 69.3431 123 71 123H147C148.657 123 150 121.657 150 120V117C150 115.343 148.657 114 147 114H71Z",
    fill: "#459BFF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147 136H71C69.8954 136 69 136.895 69 138V141C69 142.105 69.8954 143 71 143H147C148.105 143 149 142.105 149 141V138C149 136.895 148.105 136 147 136ZM71 135C69.3431 135 68 136.343 68 138V141C68 142.657 69.3431 144 71 144H147C148.657 144 150 142.657 150 141V138C150 136.343 148.657 135 147 135H71Z",
    fill: "#459BFF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147 157H71C69.8954 157 69 157.895 69 159V162C69 163.105 69.8954 164 71 164H147C148.105 164 149 163.105 149 162V159C149 157.895 148.105 157 147 157ZM71 156C69.3431 156 68 157.343 68 159V162C68 163.657 69.3431 165 71 165H147C148.657 165 150 163.657 150 162V159C150 157.343 148.657 156 147 156H71Z",
    fill: "#459BFF"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 158,
    width: 1,
    height: 5,
    fill: "#4A4A4A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFte3);
export default __webpack_public_path__ + "static/media/FTE3.d768dde6f9d349ed36bf8d8fb61fbb1c.svg";
export { ForwardRef as ReactComponent };